import { render, staticRenderFns } from "./end-game.vue?vue&type=template&id=46e2dffd&scoped=true&"
import script from "./end-game.vue?vue&type=script&lang=js&"
export * from "./end-game.vue?vue&type=script&lang=js&"
import style0 from "./end-game.vue?vue&type=style&index=0&id=46e2dffd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e2dffd",
  null
  
)

export default component.exports